import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import moment from 'moment';
import Sortable from 'sortablejs';
import { getpaymentList, updatePayment, updatePaymentListSort, getpaymentDetail, updatePaymentStatus as _updatePaymentStatus } from '@/services/systemsetting';
export default {
  name: 'payment',
  components: {},
  i18n: require('./../i18n-basucSettings'),
  computed: {
    uploadLimit: function uploadLimit() {
      return localStorage.uploadLimit;
    }
  },
  data: function data() {
    return {
      loading: false,
      loadingSave: false,
      rules: {
        partnerCode: [{
          required: true,
          message: this.$t('publicuse.pleaseinput'),
          trigger: 'blur'
        }],
        credentialCode: [{
          required: true,
          message: this.$t('publicuse.pleaseinput'),
          trigger: 'blur'
        }],
        paymentTimeout: [{
          required: true,
          message: this.$t('basicSettings.enterPleasePaymentTimeout'),
          trigger: 'blur'
        }],
        alipayPublicKey: [{
          required: true,
          message: this.$t('publicuse.pleaseinput'),
          trigger: 'blur'
        }]
      },
      paymentTimeoutUnitList: [],
      //标签类型
      defaultLangObj: {},
      imageHost: "",
      dataList: [],
      //列表数据
      isTableLoading: false,
      dialogStatus: '',
      //新建/修改状态位
      visible: false,
      //新建/修改 显示
      languageList: [],
      datavalue: {
        paymentId: '',
        nameList: [],
        partnerCode: '',
        credentialCode: '',
        //微信支付
        alipayPublicKey: '',
        payType: "",
        paymentTimeout: '',
        paymentTimeoutUnit: 0,
        blackUse: 1,
        paymentIcon: '',
        imageHost: '',
        status: ''
      },
      updateData: {},
      action: "",
      isDefault: true
    };
  },
  mounted: function mounted() {
    console.log('payment');
    var self = this;
    self.updateData = {
      type: 6
    };
    self.action = process.env.VUE_APP_API_BASE_URL + "/common/upload/";
    self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
    self.languageList = JSON.parse(localStorage.getItem('langList'));
    self.loadData();
    self.setSort();
  },
  methods: {
    gochargesSetting: function gochargesSetting() {
      this.$router.push({
        path: '/systemsetting/feesetting'
      });
    },
    handleChangeIcon: function handleChangeIcon(info) {
      if (info.file.status === 'uploading') {
        this.loadingIcon = true;
        return;
      }
      if (info.file.status === 'done') {
        if (info.file.response.code == 200) {
          this.datavalue.paymentIcon = info.file.response.data.uploadfilepath;
          this.loadingIcon = false;
        }
      }
    },
    beforeUpload: function beforeUpload(file) {
      var isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('public.pictureType'));
      }
      var isLt2M = file.size / 1024 / 1024 < this.uploadLimit;
      if (!isLt2M) {
        this.$message.error(this.$t('public.pictureMax', {
          uploadLimit: this.uploadLimit
        }));
      }
      return isJpgOrPng && isLt2M;
    },
    //排序
    setSort: function setSort() {
      var _this = this;
      console.log('sort');
      var el = document.querySelectorAll('.ant-table-body > table > tbody')[0];
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost',
        // Class name for the drop placeholder,
        setData: function setData(dataTransfer) {
          dataTransfer.setData('Text', '');
        },
        onEnd: function onEnd(evt) {
          console.log(_this.dataList);
          var targetRow = _this.dataList.splice(evt.oldIndex, 1)[0];
          _this.dataList.splice(evt.newIndex, 0, targetRow);
          // //重新设置序号
          var updateList = [];
          for (var i = 0; i < _this.dataList.length; i++) {
            var updateData = new Object();
            updateData.paymentIndex = i + 1;
            updateData.paymentId = _this.dataList[i].id;
            updateList.push(updateData);
          }
          //更新排序
          updatePaymentListSort(updateList).then(function (res) {
            if (res.data.code == 200) {
              _this.loadData();
              _this.$message.success(_this.$t('public.updateSuccessfully'));
            } else {
              _this.$notification.error({
                message: res.data.message
              });
            }
          });
        }
      });
    },
    //加载列表数据
    loadData: function loadData() {
      var self = this;
      self.isTableLoading = true;
      getpaymentList().then(function (res) {
        if (res.data.code == 200) {
          self.imageHost = res.data.data.imageHost;
          self.dataList = res.data.data.list;
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      }).finally(function () {
        self.isTableLoading = false;
      });
    },
    /* 启用停用按钮 */onUpdateStatus: function onUpdateStatus(data) {
      var self = this;
      self.dataList.map(function (item) {
        if (item.name == data.name) {
          item.status = item.status == '0' ? '1' : '0';
        }
      });
      this.$message.success(this.$t('public.updateSuccessfully'));
    },
    /* 编辑按钮 */edit: function edit(record) {
      var _this2 = this;
      console.log('111', record);
      if (record.paymentType === 1 && record.provider === 1) {
        console.log(123);
        this.isDefault = false;
      } else {
        this.isDefault = true;
      }
      var self = this;
      getpaymentDetail(record.id).then(function (res) {
        if (res.data.code == 200) {
          console.log(res.data);
          var nameList = [];
          self.languageList.forEach(function (item) {
            var nameDetail = {};
            nameDetail.langId = item.langId;
            if (item.langId == self.defaultLangObj.langId) {
              nameDetail.required = true;
            } else {
              nameDetail.required = false;
            }
            nameDetail.languageName = _this2.$t('publicuse.name') + "(" + item.langName + ')';
            nameDetail.languageBankInformation = _this2.$t('basicSettings.makeCollectionsBankInformation') + "(" + item.langName + ')';
            res.data.data.paymentNameList.forEach(function (item2) {
              if (item.langId == item2.langId) {
                nameDetail.name = item2.name;
                nameDetail.bankTransferInfo = item2.bankTransferInfo;
                nameDetail.id = item2.id;
              }
            });
            nameList.push(nameDetail);
          });

          // 如果是便利店，只有天，其他在线支付的按照正常的来
          if (res.data.data.paymentId == 3) {
            self.paymentTimeoutUnitList = [{
              value: 2,
              text: _this2.$t('basicSettings.day')
            }]; //标签类型
          } else {
            self.paymentTimeoutUnitList = [{
              value: 0,
              text: _this2.$t('basicSettings.minute')
            }, {
              value: 1,
              text: _this2.$t('basicSettings.hour')
            }, {
              value: 2,
              text: _this2.$t('basicSettings.day')
            }]; //标签类型
          }
          self.datavalue.nameList = nameList;
          self.datavalue.paymentId = res.data.data.paymentId;
          self.datavalue.payType = res.data.data.paymentType;
          self.datavalue.alipayPublicKey = res.data.data.alipayPublicKey;
          self.datavalue.imageHost = res.data.data.imageHost;
          self.datavalue.paymentIcon = res.data.data.paymentIcon;
          self.datavalue.partnerCode = res.data.data.partnerCode;
          self.datavalue.credentialCode = res.data.data.credentialCode;
          self.datavalue.paymentTimeoutUnit = res.data.data.paymentTimeoutType;
          self.datavalue.paymentTimeout = res.data.data.paymentTimeout;
          self.datavalue.blackUse = res.data.data.blackUse;
        } else {
          self.$notification.error({
            message: res.message
          });
        }
      });
      self.visible = true;
    },
    /* 取消按钮 */resetFormDate: function resetFormDate() {
      this.visible = false;
    },
    /*更新 支付方式信息 */update: function update() {
      var _this3 = this;
      var self = this;
      //多语言参数
      var nameList = self.datavalue.nameList.map(function (obj) {
        var nameDetail = {
          name: obj.name,
          id: obj.id,
          langId: obj.langId,
          bankTransferInfo: obj.bankTransferInfo
        };
        return nameDetail;
      });
      var param = {
        paymentId: self.datavalue.paymentId,
        paymentType: self.datavalue.payType,
        paymentNameList: nameList,
        paymentIcon: self.datavalue.paymentIcon,
        partnerCode: self.datavalue.partnerCode,
        credentialCode: self.datavalue.credentialCode,
        alipayPublicKey: self.datavalue.alipayPublicKey,
        paymentTimeoutType: self.datavalue.paymentTimeoutUnit,
        paymentTimeout: self.datavalue.paymentTimeout,
        blackUse: self.datavalue.blackUse
      };
      self.$refs.dataForm.validate(function (valid) {
        if (valid) {
          self.loadingSave = true;
          updatePayment(param).then(function (res) {
            self.loadingSave = false;
            if (res.data.code == 200) {
              _this3.loadData();
              self.visible = false;
              _this3.$message.success(_this3.$t('public.updateSuccessfully'));
            }
          });
        }
      });
    },
    //更新支付方式状态
    updatePaymentStatus: function updatePaymentStatus(data) {
      var _this4 = this;
      var self = this;
      var param = {
        id: data.id,
        status: data.paymentStatus == 0 ? 1 : 0
      };
      _updatePaymentStatus(param).then(function (res) {
        if (res.data.code == 200) {
          _this4.loadData();
          _this4.$message.success(_this4.$t('public.updateSuccessfully'));
        }
      });
    }
  }
};